import React from 'react';

import styled from 'styled-components';

import Shimmer from '../animation/Shimmer';

const Container = styled.div`
    position: relative;
`;

const Header = styled.div`
    padding: 1rem;
`;

const Select = styled.div`
    border-radius: 4px;
    height: 42px;
    max-width: 250px;
    width: 100%;
    background-color: ${(props) => props.theme.colors.loadingBackground};
`;

const TableRow = styled.div`
    border-radius: 4px;
    height: calc(45px - 0.75rem);
    margin: 0.75rem 0;
    width: 100%;
    background-color: ${(props) => props.theme.colors.loadingBackground};
`;

const Padding = styled.div`
    padding: 3rem 1rem;
`;

const AttendanceLoading: React.FC = () => (
    <Container>
        <Shimmer />
        <Header>
            <Select />
        </Header>
        <Padding>
            <TableRow />
            <TableRow />
            <TableRow />
            <TableRow />
            <TableRow />
            <TableRow />
        </Padding>
    </Container>
);

export default AttendanceLoading;
